<section class="box-border w-full rounded-sm border border-solid">
  <table-toolbar [resourceTableService]="resourceTableService"></table-toolbar>
  <table-content [resourceTableService]="resourceTableService"></table-content>
</section>
